export default __webpack_public_path__ + "static/O0130-a0446a23427e484eab7ec14d45cc97e2.png";